import { useTranslation } from "react-i18next";

import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import Button from "src/components/Button";
import { useCourseRelationsContext } from "src/context/CourseRelationsContext";

import type { CourseTreeActionCourse } from "./types";

const CourseActions = ({ course }: { course: CourseTreeActionCourse }) => {
  const { t } = useTranslation();
  const actions = useCourseRelationsContext();
  if (course.crewId || actions.isSuperAdmin()) {
    return (
      <Button
        title={t("course_tree.remove_relation")}
        icon={<DeleteIcon />}
        onClick={() => {
          actions.deleteRelation(course);
        }}
      />
    );
  }
  if (course.hidden) {
    return (
      <Button
        title={t("course_tree.show_course_for_position")}
        icon={<VisibilityIcon />}
        onClick={() => {
          actions.toggleCourseVisibility(course);
        }}
      />
    );
  }

  return (
    <Button
      title={t("course_tree.hide_course_for_position")}
      icon={<VisibilityOffIcon />}
      onClick={() => {
        actions.toggleCourseVisibility(course);
      }}
    />
  );
};

export default CourseActions;
